import { useMsal } from "@azure/msal-react";
import { useCallback, useEffect, useMemo, useState } from "react";
import ResourcesService from "../Services/ResourcesService";
import { toast } from "react-toastify";
import ResourceRentingModal from "../Components/ResourceRentingModal";
import ResourceRentModel from "../Models/ResourceRentModel";
import { format, parseJSON } from "date-fns";
import { useMediaQuery } from "react-responsive";

const Resources = () => {
  const { instance } = useMsal();

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 991px)" });

  const resourcesService = useMemo(
    () => new ResourcesService(instance),
    [instance],
  );

  const [resources, setResources] = useState<ResourceRentModel[]>([]);
  const [filteredResources, setFilteredResources] = useState<
    ResourceRentModel[]
  >([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectedResource, setSelectedResource] = useState<ResourceRentModel>();

  const loadResources = useCallback(async () => {
    try {
      const data = await resourcesService.getRents();

      setResources(data);
    } catch (error) {
      toast.error("Fout bij het ophalen van de data.");
    }
  }, [resourcesService]);

  useEffect(() => {
    loadResources();
  }, [loadResources]);

  useEffect(() => {
    if (
      searchValue !== undefined &&
      searchValue !== null &&
      resources.length > 0
    ) {
      setFilteredResources(
        resources.filter(
          (r) => (r.resourceName ?? "").indexOf(searchValue) > -1,
        ),
      );
    }
  }, [searchValue, resources]);

  async function afterSave() {
    try {
      setShowModal(false);

      await loadResources();
    } catch (err) {
      toast.error("Fout bij het ophalen van de data.");
    }
  }

  function afterCancel() {
    setShowModal(false);
  }

  let modal = null;
  if (showModal && selectedResource) {
    modal = (
      <ResourceRentingModal
        resource={{
          id: selectedResource.resourceId,
          name: selectedResource.resourceName,
          code: selectedResource.resourceCode,
          description: selectedResource.resourceDescription,
        }}
        afterSave={() => afterSave()}
        afterCancel={() => afterCancel()}
      />
    );
  }

  const table = (
    <table className="table table-sm text-nowrap">
      <thead>
        <tr>
          <th>Nummer</th>
          <th>Naam</th>
          <th>Omschrijving</th>
          <th>Tot</th>
          <th>Ingeleverd</th>
          <th>Door</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {filteredResources.map((record, index) => {
          return (
            <tr key={record.resourceId}>
              <td>{record.resourceCode}</td>
              <td>{record.resourceName}</td>
              <td>{record.resourceDescription}</td>
              <td>
                {!record.until
                  ? ""
                  : format(parseJSON(record.until), "dd/MM/yyyy")}
              </td>
              <td>
                {record.isReturned === undefined || record.isReturned === null
                  ? ""
                  : record.isReturned === false
                    ? "Niet ingeleverd"
                    : ""}
              </td>
              <td>{record.createdBy}</td>
              <td>
                <button
                  type="button"
                  title="Aanpassen"
                  className="btn btn-link p-0  mr-3"
                  onClick={() => {
                    setShowModal(true);
                    setSelectedResource(record);
                  }}
                >
                  <i className="fas fa-info"></i>
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  const cards = (
    <div className="row">
      {filteredResources.map((record, index) => {
        return (
          <div className="col-md-6" key={record.resourceId}>
            <div
              className="card mb-3"
              onClick={() => {
                setShowModal(true);
                setSelectedResource(record);
              }}
            >
              <div className="card-header">
                {record.resourceCode} - {record.resourceName}
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col">{record.resourceDescription}</div>
                </div>
              </div>
              {record.isReturned === false ? (
                <div className="card-footer text-muted">
                  Ontleend tot{" "}
                  {!record.until
                    ? ""
                    : format(parseJSON(record.until), "dd/MM/yyyy")}{" "}
                  door {record.createdBy}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="container-fluid">
      <div className="card mb-3">
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col">
                <input
                  type="text"
                  onChange={(e) => setSearchValue(e.target.value)}
                  className="form-control"
                  placeholder="Zoek"
                  value={searchValue}
                />
              </div>
            </div>
          </form>
          <div className="row">
            <div className="col"></div>
          </div>
        </div>
      </div>

      {isTabletOrMobile ? cards : table}

      {modal}
    </div>
  );
};

export default Resources;
